/* ============================================================
   OCP — LEARNING CENTER behaviour (multi-section)
   The nav (sidebar + mobile pill rail) is its own section; each fiber is its own section.
   This script:
     • builds the nav links from the fiber sections present in the DOM (auto-synced),
     • scroll-spies the active fiber and pins/shows the nav only while a fiber is on screen,
     • smooth-scrolls on click.
   Loaded (deferred) by the fiber section; guarded so it initialises once even if emitted twice.
   ============================================================ */
(function () {
  "use strict";
  if (window.__ocpLearningInit) return;
  window.__ocpLearningInit = true;

  function init() {
    var nav = document.querySelector('[data-learning-nav]');
    var fibers = Array.prototype.slice.call(document.querySelectorAll('.lc-fiber[id]'));
    if (!fibers.length) return;

    // copy each comparison table's column headers onto its value cells (drives the mobile "Col — value" labels)
    document.querySelectorAll('.lc-compare[data-col2]').forEach(function (t) {
      var c2 = t.getAttribute('data-col2'), c3 = t.getAttribute('data-col3');
      if (c2) t.querySelectorAll('.lc-compare__cell--v2').forEach(function (c) { c.setAttribute('data-col', c2); });
      if (c3) t.querySelectorAll('.lc-compare__cell--v3').forEach(function (c) { c.setAttribute('data-col', c3); });
    });

    var sideNav = nav && nav.querySelector('.lc-sidebar__nav');
    var pillNav = nav && nav.querySelector('.lc-pill-nav');

    // ---- build nav links from the fiber sections (label from data-nav-label or the title) ----
    function labelOf(f) {
      return (f.getAttribute('data-nav-label') || '').trim() ||
             ((f.querySelector('.lc-fiber__title') || {}).textContent || f.id).trim();
    }
    var byId = {};
    fibers.forEach(function (f) {
      var id = f.id, label = labelOf(f);
      function mk(cls, container) {
        if (!container) return;
        var a = document.createElement('a');
        a.href = '#' + id;
        a.className = cls;
        a.setAttribute('data-spy', id);
        a.textContent = label;
        container.appendChild(a);
        (byId[id] = byId[id] || []).push(a);
      }
      mk('lc-side-link', sideNav);
      mk('lc-pill', pillNav);
    });

    var tabs = byId; // id -> [link els]
    var allTabs = [];
    Object.keys(tabs).forEach(function (k) { allTabs = allTabs.concat(tabs[k]); });

    function setActive(id, alignTab) {
      allTabs.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-spy') === id); });
      if (alignTab && tabs[id]) {
        tabs[id].forEach(function (a) { a.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); });
      }
    }

    // ---- click → smooth scroll to the fiber ----
    allTabs.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('data-spy');
        var panel = document.getElementById(id);
        if (!panel) return;
        e.preventDefault();
        setActive(id, true);
        var offset = window.matchMedia('(max-width: 1100px)').matches ? 80 : 24;
        var top = panel.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });

    // ---- honour an incoming hash, else default to the first fiber ----
    var initial = location.hash.replace('#', '');
    if (initial && tabs[initial]) setActive(initial, false);
    else if (fibers[0]) setActive(fibers[0].id, false);

    // ---- scroll-spy + show/hide the pinned nav (one observer drives both) ----
    if (!('IntersectionObserver' in window) || !nav) return;
    // ---- scroll-spy (active tab) — reading band in the upper-middle of the viewport ----
    var ratio = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { ratio[en.target.id] = en.isIntersecting ? en.intersectionRatio : 0; });
      var best = null, bestR = -1;
      fibers.forEach(function (f) {
        var r = ratio[f.id] || 0;
        if (r > bestR) { bestR = r; best = f.id; }
      });
      if (bestR > 0 && best) setActive(best, false); // highlight the most-visible fiber
    }, { rootMargin: '-18% 0px -52% 0px', threshold: [0, 0.05, 0.25, 0.6] });
    fibers.forEach(function (f) { observer.observe(f); });

    // ---- pin the nav ONLY while the fiber content region sits at the top of the viewport ----
    // The sidebar/pill is position:fixed, so we gate it on the .lc-fiber-wrap region's bounds: it turns on
    // once the first fiber-wrap reaches the pin line (so it's sticky *alongside* .lc-fiber-wrap, never
    // floating over the hero/intro above it) and turns off after the last fiber-wrap scrolls past.
    var firstFiber = fibers[0], lastFiber = fibers[fibers.length - 1];
    var pinScheduled = false;
    function updatePin() {
      pinScheduled = false;
      if (!firstFiber || !lastFiber) return;
      // Gate on the first fiber's heading (not the wrap, whose top padding/preceding band sits ~96px
      // higher) and align the pin line with the sidebar's fixed top (24px), so the nav reveals exactly
      // as "Organic Cotton" reaches the top — never floating above it. Mobile pill sits lower (88px).
      var pin = window.matchMedia('(max-width: 1100px)').matches ? 88 : 24;
      var top = firstFiber.getBoundingClientRect().top;
      var bottom = lastFiber.getBoundingClientRect().bottom;
      // Hide once the last fiber no longer spans the rail's own height rather than waiting for it to
      // reach the pin line: the rail is several hundred pixels tall, so by then it is already sitting
      // over whatever follows the fibers.
      var rail = nav.querySelector('.lc-sidebar') || nav.querySelector('.lc-pill-shell');
      var railEnd = pin + (rail ? rail.offsetHeight : 0);
      nav.classList.toggle('is-on', top <= pin && bottom > railEnd);
    }
    function onScroll() { if (!pinScheduled) { pinScheduled = true; requestAnimationFrame(updatePin); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updatePin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
